import {
  Tabs,
  PopupDialogbox,
} from "../../../../../CommonComponents";
import "./AddEditUser.scss";
import SecurityRoleGrid from "./SecurityRole/SecurityRoleGrid-Container";
import SecurityPermissionGrid from "./SecurityPermission/SecurityPermission-container";
import GeneralInformation from "./GeneralInformation/GeneralInformation";
import { useSelector } from "react-redux";

interface IProps {
  userHandleChange?: Function;
  handleClickSave?: any;
  userFormError?: any;
  userForm?: any;
  selectedUserId?: any
  fetchUserByUpn: () => void;
  handleLinkClick?: any;
  selectedKey?: any;
  contentVal?: any;
  divisionData: any;
  costcenterDropdown: any;
  setUserForm?: any;
  initialValues?: any;
  setUserFormError?: any;
  initialError?: any;
  Popupcontent?: any
}
const AddEditUser = ({
  userHandleChange,
  handleClickSave,
  userFormError,
  userForm,
  selectedUserId,
  fetchUserByUpn,
  handleLinkClick,
  selectedKey,
  divisionData,
  costcenterDropdown,
  setUserForm,
  initialValues,
  setUserFormError,
  initialError,
  Popupcontent
}: IProps) => {
  const { addUserVal, checkUser } = useSelector((state: any) => ({
    addUserVal: state.UserManagement.addUserVal,
    checkUser: state.UserManagement.checkUser
  }))

  const tabItems = [
    {
      itemKey: "General",
      headerText: "General",
      content: <GeneralInformation setUserForm={setUserForm} initialError={initialError} setUserFormError={setUserFormError} initialValues={initialValues} costcenterDropdown={costcenterDropdown} divisionData={divisionData} userHandleChange={userHandleChange} fetchUserByUpn={fetchUserByUpn} handleClickSave={handleClickSave} userFormError={userFormError} userForm={userForm} />
    },
    {
      itemKey: "securityRole",
      headerText: "Security Role",
      content: <SecurityRoleGrid selectedUserId={selectedUserId} userForm={userForm} />
    },
    // {
    //   itemKey: "securityPermission",
    //   headerText: "Security Permission",
    //   content: <SecurityPermissionGrid selectedUserId={selectedUserId} userForm={userForm} />,
    // },
  ];

  return (
    <div>
      <Tabs className={`custom-tab`} tabItems={tabItems} handleLinkClick={handleLinkClick} selectedKey={selectedKey}  data-attribute="AddEditUser_Default_Tabs" />
      {(selectedUserId < 1 || selectedUserId == "" || addUserVal == 0 || addUserVal == "error") ? (
        <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
            actionby,
            value)}
       data-attribute="AddEditUser_Default_PopupDilalogBox" />
      ) : null}
      {addUserVal > 0 || checkUser || addUserVal == "error" ? (
        <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
            actionby,
            value)}
       data-attribute="AddEditUser_Default_PopupDilalogBox_2" />
      ) : null}
    </div>
  );
};

export default AddEditUser;
